angular.module('jv.Admin.Users.URLs.Factory',[])
    .factory('jvAdminUsersUrls', function($window){
        var usersURL = $window.jvUrls.admin + '/action/users';
        var usersAdminURL = $window.jvUrls.admin + '/action/admin/users';
        var userDetailsURL = $window.jvUrls.admin+'/action/user-details';
        var requisitionsUrl = $window.jvUrls.jhire+'/action/requisitions';
        var applicationsUrl = $window.jvUrls.jhire+'/action/application';
        var requisitionUrl = $window.jvUrls.jhire+'/action/requisition';
        var adminUrl = $window.jvUrls.admin + '/action/admin';
        var trackingUrl = $window.jvUrls.admin + '/action/tracking';

        return {
            employeeListDetails: (usersURL + '/employeeListDetails?'),
            employeeSearch: (usersURL + '/employeeSearch?'),
            employeeUpdateRole: (usersURL + '/employees/role'),
            employeeAddSuperUserRole: (trackingUrl + '/user/{0}/addSuperUserRole'),
            sendInviteTemplateList: (usersURL + '/employeeInviteTemplate'),
            saveNoteTemplateList: (usersURL + '/employeeNoteTemplate'),
            sendEmployeeInvite : (usersURL + '/sendEmployeeInvite'),
            sendAllEmployeeInvite : (usersURL + '/employees/invite'),
            sendEmployeeNote : (usersURL + '/employee/note'),
            setEmployeeLockUnlock : (usersURL+'/Employees/Lock'),
            removeEmployees : (usersURL + '/removeEmployee'),
            employeePaginationList: (usersURL + '/employee/paginationList?'),
            getMessageTemplateList : (usersURL + '/employeeMessage'),
            postEmployeeMessage : (usersURL + '/employeeMessage'),
            getEmployeeDetailsByEId: (userDetailsURL + '/{0}/details?'),
            employeeEditByEIdData: (userDetailsURL + '/employee/{0}/edit?'),
            employeeAddNewFormData: (userDetailsURL + '/employee/add?'),
            getEmployeeAdditionalInfo: (userDetailsURL + '/employee/{0}/additionalInfo?'),
            getAgencyListDetails : (usersURL+'/agencySearchInfo?'),
            getAgencyList : (usersURL+'/agencySearch?'),
            sendAgencyInvite : (usersURL+'/sendAgencyInvite'),
            sendAgencyNote: (usersURL+'/sendAgencyNote'),
            removeAgencyUser: (usersURL+'/removeAgencyUser'),
            getAgencyInviteTemplates: (usersURL+'/agencyInviteTemplate'),
            getAgencyRemoveTemplates: (usersURL+'/agencyRemoveTemplate'),
            
            agencyEditByEId: (userDetailsURL + '/agency/{0}/edit?'),
            agencyAddNew: (userDetailsURL + '/agency/add?'),
            agencyAddNewFormData : (userDetailsURL + '/agency/add'),
            requisitionListofEmployee : requisitionsUrl + '?',
            agencyListPagination: (usersURL + '/agency/paginationList?'),
            agencyCandidateAnalyticsById: (applicationsUrl + '/agency/user/{0}/candidatesCount'),
            agencyRequisitionAnalyticsById: (requisitionUrl + '/agency/user/{0}/jobsCount'),
            agencyUserDetailsById: (userDetailsURL + '/agency/{0}/details'),
            requisitionQuickView: (requisitionsUrl +'/{0}/quickView'),
            getAdminUsersSettings : (usersURL + '/fieldSettings?'),
            postEmployeeFieldSettings: (usersURL + '/fieldSettings?'),
            getAdminUsersImportSettings : (usersURL + '/importSettings?'),
            postImportSettings : (usersURL + '/importSettings?'),

            adminNavUrl: (usersURL + '/navigation/items?'),
            employeeDataUrl: (usersURL + '/employees/download'),
            getEmployeeNoteTemplate: (usersURL + '/employee/note/template'),
            getRequisitionsFilter: (requisitionsUrl + '/filters?')
        };
    });